<template>
  <page-outline :title="$t('Webheader.history')">
    <template slot="pageContent">
    <!-- <div class="layoutTop"></div> -->
      <b-container fluid class="listPage">
        <b-row>
          <b-col>
            <div class="requestsList">
              <b-row class="justify-content-start">
                <!-- Left section filtre -->
                <b-col cols="4" lg="2" xl="2" class="mb-5">
                  <b-button class="btnFilter"
                    @click="displayFilter = !displayFilter">
                    <i v-if="displayFilter" class="fa-light fa-minus"></i>
                    <i v-else class="fa-light fa-plus"></i>
                    {{ $t('filter.fltr') }}
                  </b-button>
                </b-col>
                <b-col cols="4" lg="2" xl="2" class="mb-5">
                  <b-button class="btnFilter btn-secondary"
                    @click="refreshInbox">
                    <i class="fa-light fa-rotate-right"></i>
                    {{ $t('common.rfrsh') }}
                  </b-button>
                </b-col>
                <!-- Right section filtre -->
                <!-- <b-button class="btn btnFilter_2 ml-2"
                  @click="exportList()">
                  <i class="fa-light fa-upload"></i>
                  <span class="fab-label">{{ $t('common.extract_list') }}</span>
                </b-button> -->
                <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
                <b-col cols="4" lg="2" xl="2" class="mb-5">
                  <b-button v-if="inboxMessages.length > 0"
                    @click="extractCSV">
                    <i class="fa-light fa-upload fs-14px"></i>
                    <span class="fab-label">{{ $t('common.extract') }}</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="min-w-100" v-if="displayFilter">
                <!-- Filtre date de début -->
                <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
                  <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                    :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
                    :inputLabel="$t('common.date_start_label')"
                    customInputParentClass="filter-item-content"
                    customInputClass="w-100"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    inputIcon="fa-solid fa-calendar"
                    v-model="dateBegin">
                  </datetime-picker-custom>
                </b-col>
                <!-- Filtre date de fin -->
                <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
                  <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                    :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
                    :inputLabel="$t('common.date_end_label')"
                    customInputParentClass="filter-item-content"
                    customInputClass="w-100"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    inputIcon="fa-solid fa-calendar"
                    v-model="dateEnd">
                  </datetime-picker-custom>
                </b-col>

                <!--Filtre actionType sans pb chevron-->
                <!--<div class="filter-item col-4 mb-5 text-truncate">
                  <span class="filter-item-title text-ellipsis" :title="$t('common.status.status_label')">
                    {{ $t('common.status.status_label') }}
                  </span>
                  <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                    href="#">
                    <!~~ <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> ~~>
                    <span :class="'fixed-span-size '">{{ 'test' }}</span>
                    <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
                  </a>
                  <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
                    triggers="focus" placement="bottom">
                    <span>
                      <select v-model="actionType">
                        <option value="">{{ $t('history.slct_actn') }}</option>
                        <option v-for="(label, type) in actionList" :key="type" :value="type" :title="label">{{ label }}</option>
                      </select>
                    </span>
                  </b-popover>
                </div>-->
                <!-- Filtre user login -->
                <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
                  <label class="filter-item-title" for="action-login">{{ $t('administration.identifier') }}</label>
                  <span class="filter-item-content">
                    <input v-model="login"
                      id="action-login"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': login}"
                      :placeholder="$t('administration.identifier')">
                  </span>
                </b-col>

                <!-- Filtre user name -->
                <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
                  <label class="filter-item-title" for="action-user">{{ $t('administration.user_name') }}</label>
                  <span class="filter-item-content">
                    <input v-model="user"
                      id="action-user"
                      type="text"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
                      :placeholder="$t('administration.user_name')">
                  </span>
                </b-col>

                <!--Filtre actionType -->
                <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">
                  <label for="action-type">
                    {{ $t('common.action_type') }}
                  </label>
                  <select class="filter-item-content min-w-100" v-model="actionType" id="select-action-type" style="padding:0.5rem">
                    <option value="" disabled>{{ $t('history.slct_actn') }}</option>
                    <option v-for="(label, type) in actionList" :key="type" :value="type" :title="label">{{ label }}</option>
                  </select>
                </b-col>

                <!-- Bouton Effacer et Appliquer -->
                <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-4">
                  <b-button size="sm"
                    @click="applyFilter">
                    {{ $t('common.srch') }}
                  </b-button>
                  <b-button class="mr-3" size="sm"
                    @click="clearFilterFields"
                    :disabled="!hasInputFilter">
                    {{ $t('filter.clr_fltr_field') }}
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="min-w-100">
                <b-col sm="12" lg="12" cols="12">
                  <spinner v-if="activateSpinner"></spinner>
                  <div class="w-100" v-else>
                    <!-- <span v-if="inboxMessages.length" class="font-weight-bold">{{ $t('common.results_actions_desc') + paginationObject.nbResultsTotal}}</span> -->
                    <b-table responsive hover borderless outlined class="table mt-3 text-center table-striped"
                             v-if="inboxMessages.length"
                             :items="inboxMessages"
                             :fields="historyFields"
                             :key="resetHisto">
                      <template #cell(dateAction)="data"><div class="cursor text-ellipsis"><span>{{getDate(data.value)}}</span></div></template>
                      <template #cell(name)="data">
                        <div v-if="!data.value">-</div>
                        <div v-else>{{ data.value }}</div>
                      </template>
                      <template #cell(label)="data">
                        <span v-if="!translateDetails(data.item.details, data.item).length">{{data.value}}</span>
                        <f7-accordion-item v-else class="accordionForm"
                                           :expanded="data.item.open"
                                           @accordion:open="data.item.open=true"
                                           @accordion:opened="data.item.openFinished=true;resetHisto = !resetHisto"
                                           @accordion:close="data.item.open=data.item.open=false"
                                           @accordion:closed="data.item.openFinished=false;resetHisto = !resetHisto">
                          <f7-accordion-toggle class="accordionToggle">
                            <div class="form-group row justify-content-center">
                              <div class="col-sm-auto">
                                {{ data.value }}
                                <i class="ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue"
                                   v-if="data.item.open === true">
                                </i>
                                <i class="ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue"
                                   v-else>
                                </i>
                              </div>
                            </div>
                          </f7-accordion-toggle>
                          <f7-accordion-content :class="{accordionContentExpended: data.item.openFinished}">
                            <div v-for="(detail, index) in translateDetails(data.item.details, data.item)" :key="index">
                          <span v-if="isRTPAction(data.item)" class="cursor" @click="detailsRTP(data.item)"><u>
                            {{ $t('history.rtp_details') }}</u>
                          </span>
                              <span v-else><span><b>{{detail.name}} </b></span><span v-if="detail.old">{{detail.old}}&nbsp;<b>→</b>&nbsp;</span><span>{{detail.value}}</span></span>
                            </div>
                          </f7-accordion-content>
                        </f7-accordion-item>
                      </template>
                    </b-table>
                    <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="!activateSpinner" class="mt-1">
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </b-container>
  <!-- </f7-page> -->
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import dateTimePicker from '@/components/common/dateTimePicker.vue'
import MessagesFilter from '@/components/common/Filter'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'

import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import { errorMessageAlert } from '@/helpers/alert'
import { formatDateTime } from '@/helpers/format'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'Inbox',
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': Pagination,
    'datetime-picker-custom': dateTimePicker,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    actionList () {
      return {
        1: this.$i18n.t('history.action_type.1'),
        2: this.$i18n.t('history.action_type.2'),
        3: this.$i18n.t('history.action_type.3'),
        4: this.$i18n.t('history.action_type.4'),
        5: this.$i18n.t('history.action_type.5'),
        6: this.$i18n.t('history.action_type.6'),
        7: this.$i18n.t('history.action_type.7')
      }
    },
    appLanguage () {
      return this.$i18n.locale
    },
    hasAdminHistoryConsulter() {
      return this.$engine.rights.rightIs('history_consult_admin', true)
    },
    historyFields () {
      let fields = [
        { key: 'dateAction', label: this.$t('common.date_label'), class: 'text-center col-3' },
        { key: 'login', label: this.$t('administration.identifier'), class: 'text-center col-3'},
        { key: 'name', label: this.$t('administration.user_name'), class: 'text-center col-3' },
        { key: 'label', label: this.$t('common.action_label'), class: 'text-center col-3' }
      ]
      return fields
    },
    hasInputFilter () {
      if (
        this.dateBegin ||
        this.dateEnd ||
        this.endToEndId ||
        this.actionType ||
        this.login ||
        this.user) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      actionType: '',
      activateSpinner: false,
      completeList: [],
      currentIndex: 1,
      dateBegin: '',
      dateEnd: '',
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      inboxMessages: [],
      login: '',
      mode: 1,
      name: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      reload: false,
      resetHisto: false,
      requestsNumber: '',
      scrollFlag: true,
      serviceId : this.$engine.user.currentService.id.toString(),
      sortDirection: 'DESC',
      sortField: 'dateAction',
      timer: '',
      user: ''
    }
  },
  created () {
    this.reload = false
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Historique',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'history-page'
    this.$bus.$off('history-page')
    this.$bus.$on('history-page', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    // this.filterTypeGet = this.filterType
    // this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.history.cleanFilterCondition()
  },
  methods: {
    applyFilter () {
      let filterConditions = {}
      clearTimeout(this.timer)
      this.reload = true
      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login.trim()
      filterConditions.name = this.user.trim()
      filterConditions.typeAction = this.actionType
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let that = this
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex

      this.activateSpinner = true
      this.$engine.history.update(
        filterConditions
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResultsTotal = 0
        that.paginationObject.nbResults = 0

        if (resp.data && resp.data.actionHistory && resp.data.actionHistory.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          that.paginationObject.nbResults = resp.data.actionHistory.length
          requests = resp.data.actionHistory
        }
        // requests = requests.slice(that.paginationObject.firstIndex - 1, that.paginationObject.firstIndex - 1 + that.paginationObject.maxResults)
        that.updateInbox(requests)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    delayApplyFilter() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilter()
      }, 1500)
    },
    detailsRTP (item) {
      if (this.isJSON(item.details)) {
        let parsed = JSON.parse(item.details)
        let idRequest = parsed[0].value
        this.$engine.services.payments.idRequest = idRequest
        this.$bus.$emit('switch-selected-menu', '/rtp/listBack/2/1/0')
        loadPage(this, {url: '/payments/transaction-details/' + idRequest})
      }
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.dateBegin = ''
      this.dateEnd = ''
      this.endToEndId = ''
      this.actionType = ''
      this.login = ''
      this.user = ''
      this.communicateChange()
      // this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV () {
      let firstLine = ''
      firstLine =
        this.$t('common.date_label') + ';' +
        this.$t('administration.company_name') + ';' +
        this.$t('administration.identifier') + ';' +
        this.$t('administration.user_name') + ';' +
        this.$t('common.action_label') +
        ' \r\n'

      let lines = ''
      let that = this

      // this.scrollFlag = true
      let filterConditions = {}
      //this.reload = true

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login.trim()
      filterConditions.name = this.user.trim()
      filterConditions.typeAction = this.actionType
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      this.$engine.history.update(
        filterConditions
      ).then(resp => {
        let historyMessagesCSV = {}
        historyMessagesCSV = resp.data.actionHistory

        for (let datas in historyMessagesCSV) {
          let actionDate = historyMessagesCSV[datas].dateAction ? moment.utc(historyMessagesCSV[datas].dateAction).local().format('YYYY-MM-DD HH:mm:ss') : '-'
          let company = historyMessagesCSV[datas].account ? historyMessagesCSV[datas].account : '-'
          let login = historyMessagesCSV[datas].login ? historyMessagesCSV[datas].login : '-'
          let user = historyMessagesCSV[datas].name ? historyMessagesCSV[datas].name : '-'
          let action = historyMessagesCSV[datas].label ? historyMessagesCSV[datas].label : '-'

          lines += actionDate + ';' +
          company + ';' +
          login + ';' +
          user + ';' +
          action + ';' +
          '\r\n'
        }

        let data = firstLine + lines
        that.$f7.hidePreloader()
        // const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let encodedData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        let linkSource = URL.createObjectURL(encodedData);
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.history') + '_' + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    exportList () {
      // mettre en place mode CSV coté modé
      let that = this
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login.trim()
      filterConditions.name = this.user.trim()
      filterConditions.typeAction = this.actionType

      this.$engine.history.getExport(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportActionHistory
        that.updateList(list)
        that.exportHistory()
      }).catch(e => {
        errorMessageAlert(e, that)
      })
    },
    exportHistory () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Date' + ';' +
        'Type d\'action' + ';' +
        'Utilisateur' + ';' +
        'Identifiant' + ';' +
        'Détails' + '\r\n'

      let line = atob(this.completeList.result)
      let data = firstLine + line
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'history_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isRTPAction (item) {
      return ['2','3'].includes(item.typeAction)
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      // let that = this
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.currentIndex = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login.trim()
      filterConditions.name = this.user.trim()
      filterConditions.typeAction = this.actionType

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex


      this.$engine.history.update(
        filterConditions
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResultsTotal = 0
        that.paginationObject.nbResults = 0

        if (resp.data && resp.data.actionHistory && resp.data.actionHistory.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          that.paginationObject.nbResults = resp.data.actionHistory.length
          requests = resp.data.actionHistory
        }

        that.updateInbox(requests, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.reload = true
      this.onRefresh(false, this.paginationObject['firstIndex'])
    },getDate (date) {
      if (date != ''){
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
      }
      else {
        return '-'
      }
    },
    translateDetails (details, item) {
      if (this.isJSON(details)) {
        let parsed = JSON.parse(details)
        if (['2','3'].includes(item.typeAction) && this.$engine.rights.rightIs('rtp_backoffice_consult',false)) {
          return []
        }
        return parsed
      }
      return []
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateList (requests) {
      this.completeList = requests
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  },
  watch:  {
    appLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onRefresh(false, this.currentIndex)
      }
    }
  }
}
</script>
